var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.slides.length ? _c('div', [_c('div', {
    staticClass: "slider-overlay"
  }), _c('div', {
    staticClass: "property-slider"
  }, [_c('div', {
    staticClass: "property-slider__slides touch",
    class: {
      'finite': _vm.slides.length <= 5
    }
  }, [_c('vue-slick-carousel', _vm._b({
    key: "slickKey".concat(_vm.slides ? _vm.slides.length + _vm.slides[0]._id : 0),
    on: {
      "init": _vm.onInitCarousel,
      "afterChange": _vm.sliderChanged
    },
    scopedSlots: _vm._u([{
      key: "prevArrow",
      fn: function fn() {
        return [_c('div', {
          staticClass: "property-slider__control property-slider__control--prev"
        }, [_c('button', {
          staticClass: "btn-circle touch"
        }, [_c('fa', {
          attrs: {
            "icon": ['far', 'chevron-left']
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "nextArrow",
      fn: function fn() {
        return [_c('div', {
          staticClass: "property-slider__control property-slider__control--next"
        }, [_c('button', {
          staticClass: "btn-circle touch"
        }, [_c('fa', {
          attrs: {
            "icon": ['far', 'chevron-right']
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "customPaging",
      fn: function fn(page) {
        return [_c('div', {
          staticClass: "dot"
        }, [_vm._v("\n                " + _vm._s(page) + "\n              ")])];
      }
    }], null, false, 3876446135)
  }, 'vue-slick-carousel', _vm.settings, false), _vm._l(_vm.slides, function (slide) {
    return _c('div', {
      key: slide._id,
      staticClass: "property-slider__slide touch",
      class: {
        'property-slider__slide--active': _vm.activeSlideId === slide._id
      }
    }, [_c('PropertyCard', {
      attrs: {
        "slide": slide,
        "isActive": _vm.activeSlideId === slide._id
      }
    })], 1);
  }), 0)], 1)])]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }